import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  return (
    <footer className="footer">
      <div className="container-fixed">
        <div className="flex flex-wrap gap-3 py-5">
          <div className="text-gray-500 text-2sm">
            {new Date().getFullYear()}©
          </div>
          <div className="text-gray-5D5D5D font-medium text-2sm">Trustoo.</div>
          <a
            className="text-gray-500 text-2sm border-l border-gray-300 px-2 pl-4 hover:cursor-pointer"
            onClick={() => navigate('/privacy-policy')}
          >
            {t('privacyPolicy')}
          </a>
          <a
            className="text-gray-500 text-2sm border-l border-gray-300 px-2 pl-4 hover:cursor-pointer"
            onClick={() => navigate('/cgu')}
          >
            CGU
          </a>
          <a
            className="text-gray-500 text-2sm border-l border-gray-300 px-2 pl-4 hover:cursor-pointer"
            onClick={() => navigate('/legal-mention')}
          >
            {t('legalMentions')}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
